import { useCallback, useReducer } from 'react'

import { getTokens } from '~utils/ethereum'

export default function useWatchToken({ adapter, chainId }) {
    const [added, setAdded] = useReducer((state, id) => ({
        ...state,
        [id]: true,
    }), {})

    const watch = useCallback(async () => {
        const { dataToken } = getTokens({
            chainId,
        })

        if (!adapter || !adapter.canWatchAsset() || !dataToken) {
            return
        }

        try {
            const succeeded = await adapter.getProvider().request({
                method: 'wallet_watchAsset',
                params: {
                    type: 'ERC20',
                    options: {
                        address: dataToken.address,
                        symbol: 'DATA',
                        decimals: 18,
                        image: 'https://streamr-public.s3.amazonaws.com/streamr-new-token-mark.svg',
                    },
                },
            })

            if (succeeded) {
                setAdded(chainId)
            }
        } catch (error) {
            console.error(error)
        }
    }, [adapter, chainId])

    const canWatch = !!adapter && adapter.canWatchAsset() && !added[chainId]

    return [canWatch, watch]
}
